import styled from "styled-components";

import { QUERIES, SPACING } from "../../../../../../utils/constants";

export const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${SPACING.md}px ${SPACING.lg}px;
  padding: ${SPACING.xs}px 0 ${SPACING.md}px;

  @media ${QUERIES.tabletLargeAndUp} {
    grid-template-columns: repeat(4, 1fr);
    padding-top: ${SPACING.md}px;
    border-top: 1px solid var(--color-border);
  }

  @media ${QUERIES.laptopAndUp} {
    grid-template-columns: 1.2fr 1fr 0.8fr 0.7fr 1.5fr 1fr 1fr;
  }
`;

export const Meta = styled.div<{ $isWide?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
  min-width: 0;
  grid-column: ${({ $isWide }) => ($isWide ? "1 / -1" : "auto")};

  @media ${QUERIES.tabletLargeAndUp} {
    grid-column: auto;
  }
`;

export const MetaLabel = styled.span`
  font-size: var(--text-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-secondary);
`;

export const MetaValue = styled.span<{ $color?: string }>`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-md);
  font-weight: 600;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  color: ${({ $color }) => $color ?? "var(--color-text-default)"};
`;
